import React from 'react'
import {realData, analysisData} from '../../Data/realData'
import { ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

const QualityAnalysis = () => {
  return (
    <>
      <div className="complaint-risk"> 

        <div className='chartArea'>
        <div className="chartHead">
            <h3>Distribution of Vulnerability</h3>
        </div>
        <div>
            <ComposedChart className="chart"
            width={1050}
            height={300}
            data={realData}
            margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
            }}
            >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#3CB371" />
            </ComposedChart>
        </div>
        </div>


        <div className='chartArea'>
        <div className="chartHead">
            <h3>Complaint Risk - Trend Analysis</h3>
        </div>
        <div>
            <ComposedChart className="chart"
            width={1050}
            height={200}
            data={analysisData}
            margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
            }}
            >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#8884d8" />
            </ComposedChart>
        </div>
        </div>

        <div className='chartArea'>
        <div className="chartHead">
            <h3>Complaint Risk - Trend Analysis</h3>
        </div>
        <div>
            <ComposedChart className="chart"
            width={1050}
            height={200}
            data={analysisData}
            margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
            }}
            >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#8884d8" />
            </ComposedChart>
        </div>
        </div>

        <div className='chartArea'>
        <div className="chartHead">
            <h3>Complaint Risk - Trend Analysis</h3>
        </div>
        <div>
            <ComposedChart className="chart"
            width={1050}
            height={200}
            data={analysisData}
            margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
            }}
            >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#FF2E2E" />
            </ComposedChart>
        </div>
        </div>
      </div>
    </>
  )
}

export default QualityAnalysis